import { getAuthToken, Tag } from "src/store/config";
import * as api from "./api";

interface ApiResponse {
  status: number;
  message: string;
  data: Tag[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

export const fetchTagList = async (data: {
  search?: string; 
  page: number;
  limit: number;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search) {
    params.search = data.search; 
  }

  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(`${process.env.REACT_APP_ADMIN_API_URL}/tag`, params);
  return response;
};

export const addTag = async (params: { title: string}) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.post(
      `${process.env.REACT_APP_ADMIN_API_URL}/tag`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateTag = async (
  id: string,
  params: { title: string}
) => {
  try {
    const token = getAuthToken();
    api.setHeaderAuthorization(token);
    const response = await api.put(
      `${process.env.REACT_APP_ADMIN_API_URL}/tag/${id}`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteTag = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.remove(
    `${process.env.REACT_APP_ADMIN_API_URL}/tag/${id}`
  );  
};